export default __webpack_public_path__ + "static/media/4.0993b5e0.jpg";